import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, FormsModule, ReactiveFormsModule, NgStyle, SvgIconComponent, ControlToKeyNamePipe]
})
export class CheckboxComponent implements OnInit, DoCheck {
    private internalControl: AbstractControl;

    @Input() control: AbstractControl;

    @Input() color = '#000000';
    @Input() required = false;
    @Input() checked = false;
    @Input() inline = false;
    @Input() marginBottom?: 'default' | 'small' | 'none' = 'default';

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.internalControl = { ...this.control } as AbstractControl;
    }

    // Custom changeDetection
    ngDoCheck(): void {
        const { touched: internalTouched } = this.internalControl;
        const { touched } = this.control;

        if (touched !== internalTouched) {
            this.internalControl = { ...this.control } as AbstractControl;
            this.cd.markForCheck();
        }
    }

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }
}
